import apiClient from '@src/api/clients';

const buildQueryString = (params = {}) => {
  const entries = Object.entries(params).filter(
    ([, value]) => value !== undefined && value !== null && value !== ''
  );
  if (!entries.length) {
    return '';
  }
  const search = new URLSearchParams(entries).toString();
  return search ? `?${search}` : '';
};

const googleSheetMappingsApi = {
  list(params = {}) {
    const queryString = buildQueryString(params);
    return apiClient.request({
      url: `app1/google-sheet-mappings/${queryString}`,
      method: 'GET',
    });
  },
  retrieve(id) {
    return apiClient.request({
      url: `app1/google-sheet-mappings/${id}/`,
      method: 'GET',
    });
  },
  create(payload) {
    return apiClient.request({
      url: 'app1/google-sheet-mappings/',
      method: 'POST',
      payload,
    });
  },
  update(id, payload) {
    return apiClient.request({
      url: `app1/google-sheet-mappings/${id}/`,
      method: 'PUT',
      payload,
    });
  },
  destroy(id) {
    return apiClient.request({
      url: `app1/google-sheet-mappings/${id}/`,
      method: 'DELETE',
    });
  },
  run(id) {
    return apiClient.request({
      url: `app1/google-sheet-mappings/${id}/run/`,
      method: 'POST',
    });
  },
};

export default googleSheetMappingsApi;
